import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUp, faArrowDown, faFlagCheckered } from "@fortawesome/free-solid-svg-icons"
import styled from 'styled-components';
import {useSpring, animated} from 'react-spring'


const Container = styled.div`
    width: 100%;
    height: contain;
    display: flex;
    align-items: stretch;
`
const Steps = styled.div`
    padding-top: 20px;
    div:last-child{
        p{
            border: none;
        }
    }
    
`


const Item = styled.div`
  padding-bottom: 10px;
    p{
        border-left: 1px solid rgba(0,0,0,0.4);
        padding-left: 20px;
        margin-left: 11px;
        padding-top: 10px;
        margin-top: 5px;
        padding-bottom: 30px;

    }
  &:last-child{
      padding-bottom: 0;
  }
`

const Index = styled.span`
  display: flex;


`

const Icon = styled.div`
  border-radius: 50%;
  margin-right: 10px;
  width: 22px;
  height: 22px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  display: inline-block;
  background-color: var(--dark-background);
  h4{
    color: white;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    margin-left: 1px;
  }
`

const Containerline = styled.div`
  display: inline-block;

`

export default function Stappen2({stappenplan}){
    const newsteps = stappenplan;

    return(
        <Container>
        <Containerline />
            <Steps>
            {newsteps[0].titels.map((item, index) => (

                <Item>
                <Index><Icon><h4>{index}</h4></Icon><h4>{item.titel}</h4> </Index>
                <p>
                    {newsteps[0].inhoud[index].text}
                </p>
                </Item>

            ))}
            </Steps>
        </Container>
    )
}


